import axiosInstance from '../variables/api/axiosInstance';
import i18n from '../i18n';

/**
 * À qui s'adresse la garantie d'un dossier - une seule règle pour tous les écrans.
 *
 *  - ET (véhicule étranger accidenté au Togo) : le BNCB demande la confirmation au
 *    BUREAU HOMOLOGUE du pays émetteur, qui la lui retourne.
 *  - TE (véhicule togolais accidenté à l'étranger) : le bureau homologue envoie sa
 *    fiche ; le BNCB demande la confirmation à la COMPAGNIE togolaise, qui la lui
 *    retourne.
 *
 * Le workflow doit dire en toutes lettres qui reçoit quoi : « demandée », sans
 * destinataire, laissait croire que tout partait au même endroit.
 */
export const partieGarantie = (sinistre) => (sinistre?.typeSinistre === 'SURVENU_ETRANGER'
  ? {
    role: 'COMPAGNIE',
    nomRole: i18n.t('referentiels:partieGarantie.compagnie.nomRole'),
    a: i18n.t('referentiels:partieGarantie.compagnie.a'),
    de: i18n.t('referentiels:partieGarantie.compagnie.de'),
    libelle: sinistre?.organismeMembreRaisonSociale || null,
    organismeTrackingId: sinistre?.organismeMembreTrackingId || null,
  }
  : {
    role: 'BUREAU_HOMOLOGUE',
    nomRole: i18n.t('referentiels:partieGarantie.bureauHomologue.nomRole'),
    a: i18n.t('referentiels:partieGarantie.bureauHomologue.a'),
    de: i18n.t('referentiels:partieGarantie.bureauHomologue.de'),
    libelle: sinistre?.organismeHomologueRaisonSociale || null,
    organismeTrackingId: sinistre?.organismeHomologueTrackingId || null,
  });

/** « à la compagnie SUNU Assurances », ou « à la compagnie » si le nom manque. */
export const destinataireGarantie = (sinistre) => {
  const p = partieGarantie(sinistre);
  return p.libelle ? `${p.a} ${p.libelle}` : p.a;
};

/** Une adresse en « .local » est provisoire (reprise, jeux de données) : elle n'arrive nulle part. */
export const adresseUtilisable = (email) => {
  const e = (email || '').trim();
  const arobase = e.lastIndexOf('@');
  return arobase > 0 && arobase < e.length - 1 && !/\s/.test(e) && !e.toLowerCase().endsWith('.local');
};

/** Adresse de l'organisme à qui écrire pour la garantie, si elle est utilisable. */
export const adresseGarantie = async (sinistre) => {
  const { organismeTrackingId } = partieGarantie(sinistre);
  if (!organismeTrackingId) return '';
  try {
    const r = await axiosInstance.get(`/v1/organismes/${organismeTrackingId}`, { skipErrorToast: true });
    const email = r.data?.data?.email;
    return adresseUtilisable(email) ? email.trim() : '';
  } catch {
    return '';
  }
};
